import wx from 'weixin-jsapi'
import {getShareConfig} from "@/api/login";
import utils from "@/utils/utils";


const wxShare = function (option) {
    const url = utils.getSignUrl()

    getShareConfig(encodeURIComponent(url)).then(res => { //请求后台接口
        //console.log(res)
        wx.config({
            debug: false, //是否开启debug
            appId: res.data.appId,//你的appid
            timestamp: res.data.timestamp, //时间戳
            nonceStr: res.data.nonceStr,//随机字符串
            signature: res.data.signature,//秘钥（秘钥生成规则请看我另一篇文章（php获取微信AccessToken，生成秘钥））
            jsApiList: [ //请求的api接口列表，微信的，详情去看微信官方文档
                'updateAppMessageShareData',
                'updateTimelineShareData',
                'getLocation',
                'openLocation',
                'onMenuShareAppMessage',
                'onMenuShareTimeline'
            ]
        });
        wx.ready(function () { //如果wx.config配置正常，会自动走此处
            console.log('ready执行完毕')
            wx.onMenuShareAppMessage({
                title: option.shareTitle,//分享的标题
                desc: option.shareDesc,//分享的描述信息
                link: option.shareUrl,//分享的url
                imgUrl: option.shareImg,
                type: '', // 分享类型,music、video或link，不填默认为link
                dataUrl: '', // 如果type是music或video，则要提供数据链接，默认为空
                success: function () {
                    // 用户点击了分享后执行的回调函数
                }
            });
            wx.onMenuShareTimeline({
                title: option.shareTitle,//分享的标题
                desc: option.shareDesc,
                link: option.shareUrl,
                imgUrl: option.shareImg,
                type: '', // 分享类型,music、video或link，不填默认为link
                dataUrl: '', // 如果type是music或video，则要提供数据链接，默认为空
                success: function () {
                    // 用户点击了分享后执行的回调函数
                }
            });

        });
        wx.error(function (res) { //如果wx.config配置失败,会走到此处
            console.log('error',res);
        })
    });

};

export default wxShare
